import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { NotificationService } from 'src/app/pages/notification-center/notification.service';
import { CardCenterService } from 'src/app/pages/voucher-center/card-center/card-center.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { environment } from 'src/environments/environment';
import { LeftMenuService } from '../left-menu/left-menu.service';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  domain = window.location.origin;
  isH5!: boolean;
  constructor(
    private layout: LayoutService,
    public appService: AppService,
    private notificationService: NotificationService,
    private cardCenterService: CardCenterService,
    private leftMenuService: LeftMenuService,
    public router: Router,
    private localStorageService: LocalStorageService,
  ) {}

  /** 是否是app */
  isApp!: boolean;

  /**是否登录状态 */
  logined: boolean = false;

  navMenuShow!: boolean;

  @Input() layoutContentMarginLeft: string = '0px';

  @Input() layoutContentMarginRight: string = '0px';

  /** 头部 menuitem */
  menuItems: Array<{
    menuItemName: string;
    icon: string;
    routerLink: string;
    menuIcon: string;
  }> = [
    {
      menuItemName: '',
      icon: '',
      routerLink: '',
      menuIcon: '',
    },
    {
      menuItemName: '',
      icon: '',
      routerLink: '',
      menuIcon: '',
    },
    {
      menuItemName: '',
      icon: '',
      routerLink: '',
      menuIcon: '',
    },
  ];

  /** 头部导航准备 */
  isHeaderMenuReady: boolean = false;

  /** web是否显示logo */
  logoShow: boolean = false;

  /** 当进入到全屏游戏时 */
  fullWidth: boolean = false;

  /** web是否有2级新配置菜单 */
  headerLevel2Menu: boolean = false;
  ngOnInit() {
    this.isApp = environment.isApp;

    combineLatest([
      this.layout.isH5$,
      this.layout.leftMenuInvisible$,
      this.layout.leftMenuState$.pipe(
        startWith(this.localStorageService.getValueByJsonParse('platform-left-menu-state', false)),
      ),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([isH5, invisible, state]) => {
        this.isH5 = isH5;
        if (invisible && this.router.url.split('/').includes('play')) {
          this.logoShow = true;
          this.fullWidth = true;
        } else {
          this.logoShow = !state;
          this.fullWidth = false;
        }
      });

    // 登录后如果为用户名注册显示提示弹窗
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      if (!v) return;
      this.logined = true;
      // 获取站内信 所有信息
      this.notificationService.getNoticeCounts();

      // 获取卡券数量
      this.cardCenterService.getBonusCount();
    });

    // 获取头部导航
    this.leftMenuService
      .onGetTags()
      .pipe(
        untilDestroyed(this),
        map(v => {
          const headerMenu = v?.headerMenus || [];
          this.headerLevel2Menu = v?.navigationMenus ? true : false;
          return headerMenu
            ?.filter(x => x?.key !== '0')
            ?.map(x => ({
              menuItemName: x?.name || '',
              icon: x?.icon || '',
              routerLink: `/${this.appService.languageCode}/${this.leftMenuService.getLinkByMethod(x)}`,
              menuIcon: x?.menuIcon || '',
            }));
        }),
      )
      .subscribe(data => {
        this.menuItems = data || [];
        if (data?.length) {
          this.isHeaderMenuReady = true;
        }
      });
  }

  // checkHideMenu$?: Subscription;
  // initMenuCheck(on: boolean, boxEl: HTMLDivElement, menuEl: HTMLDivElement, headerRightEl: HTMLDivElement) {
  //   if (on) {
  //     this.checkHideMenu$ = this.layout
  //       .resizeObservable(boxEl)
  //       .pipe(untilDestroyed(this))
  //       .subscribe(() => {
  //         const mw = menuEl.clientWidth;
  //         const hl = Number(getComputedStyle(headerRightEl).getPropertyValue('margin-left').replace('px', ''));
  //         this.navMenuShow = hl - mw <= 0;
  //       });
  //   } else {
  //     this.checkHideMenu$?.unsubscribe();
  //   }
  // }
}
